import nodeStates from '../constants/nodeStates';
import nodeStyles from '../constants/nodeStyles';
import findLast from 'lodash/findLast';
import { sortOrderOfArrivalNodeAtStation } from './nodeTimelineHelper';

function nodeAtSortOrder(stationNodes, sortOrder) {
    return stationNodes.find((node) => node.sortOrder === sortOrder);
}

export function stationSummaryNode(nodes) {
    const criticalNode = findLast(
        nodes,
        (x) => x.style === nodeStyles.critical
    );

    if (criticalNode != null) {
        return criticalNode;
    }

    const lastCompletedNode = findLast(
        nodes,
        (x) =>
            x.state === nodeStates.completedBag ||
            x.state === nodeStates.completedFlight ||
            x.state === nodeStates.completedReflight
    );

    if (lastCompletedNode != null) {
        return lastCompletedNode;
    }

    if (sortOrderOfArrivalNodeAtStation(nodes) !== -1) {
        return nodeAtSortOrder(nodes, sortOrderOfArrivalNodeAtStation(nodes));
    }

    return nodes[0];
}
